/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneEdge from 'sites/allas/components/standalone/Edge';

export const DynamicStandaloneEdge = StandaloneEdge;
export type DynamicStandaloneEdgeProps = PropsFromComponent<typeof StandaloneEdge>;

export const DynamicStandaloneEdgeWith = (extras: DynamicStandaloneExtras): typeof StandaloneEdge => {
    return function DynamicStandaloneEdge(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Edge');
        return <StandaloneEdge {...mergeProps({ options: { theme } }, props)} />;
    }
}